import { genericRoute } from 'utils/routeUtils';

import RugbyLeagueHomePage from './containers/RugbyLeagueHomePage';
import RugbyLeagueNav from './nav/RugbyLeagueNav';

export default genericRoute(RugbyLeagueHomePage, RugbyLeagueNav, 'rugby-league');



// WEBPACK FOOTER //
// ./modules/RugbyLeague/routes.js